module.exports = __webpack_public_path__ + "img/laptop-template-en.23f01de3.png";